module.exports = __webpack_public_path__ + "681198e67dd576dce0ac3a2e807b003b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/files.png
// module id = 58
// module chunks = 0